"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionIndex = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const answer_1 = require("../model/answer");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const icon_button_1 = require("../../../component/input/icon-button");
const log_1 = require("../../../model/log");
exports.QuestionIndex = (0, react_1.memo)(({ index, isSelected, onClick, answer, enable = true, }) => {
    const theme = (0, material_1.useTheme)();
    const textColor = (0, react_1.useMemo)(() => enable
        ? (answer === null || answer === void 0 ? void 0 : answer.state) === answer_1.AnswerResultState.Correct
            ? theme.palette.success.main
            : (answer === null || answer === void 0 ? void 0 : answer.state) === answer_1.AnswerResultState.Incorrect
                ? theme.palette.error.main
                : theme.palette.primary.main
        : theme.palette.text.disabled, [
        enable,
        answer === null || answer === void 0 ? void 0 : answer.state,
        theme.palette.success.main,
        theme.palette.error.main,
        theme.palette.primary.main,
        theme.palette.text.disabled,
    ]);
    return ((0, jsx_runtime_1.jsx)(icon_button_1.IconButton, { onClick: () => onClick(index), sx: {
            backgroundColor: isSelected
                ? textColor
                : theme.palette.background.paper,
            color: isSelected ? theme.palette.primary.contrastText : textColor,
            borderRadius: "50%",
            border: `1px solid ${isSelected ? theme.palette.primary.contrastText : textColor}`,
            width: theme.spacing(6),
            height: theme.spacing(6),
            "&:hover": {
                backgroundColor: isSelected
                    ? theme.palette.primary.dark
                    : theme.palette.grey[100],
                color: isSelected ? theme.palette.primary.contrastText : textColor,
            },
        }, disabled: !enable, eventName: log_1.LogEventClickName.QuizQuestionIndex, children: (answer === null || answer === void 0 ? void 0 : answer.state) === answer_1.AnswerResultState.Correct ? ((0, jsx_runtime_1.jsx)(icons_material_1.Check, {})) : (answer === null || answer === void 0 ? void 0 : answer.state) === answer_1.AnswerResultState.Incorrect ? ((0, jsx_runtime_1.jsx)(icons_material_1.Clear, {})) : ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", color: isSelected ? theme.palette.primary.contrastText : textColor, children: index + 1 })) }));
});
exports.QuestionIndex.displayName = "QuestionIndex";
